import { configureIntercom } from '@seek/hirer-intercom-adapter';
import { useEffect } from 'react';

import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

import { useStores } from './useStores';

export const useConfigureCandidateManagementIntercom = () => {
  const store = useStores();
  const { userStore } = store;
  const { user } = userStore;
  const { site, language } = useAppConfig();

  useEffect(() => {
    if (user.email) {
      configureIntercom({
        email: user.email,
        name: user.name,
        language,
        site,
      });
    }
  }, [user.email, user.name, language, site]);
};
